import axios from 'axios';

// When deployed behind Firebase Hosting (which rewrites /api/** to Cloud Run),
// REACT_APP_BACKEND_URL should be empty — API calls then hit the same origin
// and there is no CORS to deal with. For local dev / preview environments,
// set REACT_APP_BACKEND_URL to the backend's external origin.
const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');
export const API_BASE = `${BACKEND_URL}/api`;

const STORAGE_KEY = 'pnc_admin_basic_auth';

export function setAdminAuth(username, password) {
  const token = btoa(`${username}:${password}`);
  sessionStorage.setItem(STORAGE_KEY, token);
}

export function clearAdminAuth() {
  sessionStorage.removeItem(STORAGE_KEY);
}

export function getAdminAuth() {
  return sessionStorage.getItem(STORAGE_KEY);
}

export const apiPublic = axios.create({ baseURL: API_BASE });

export const apiAdmin = axios.create({ baseURL: API_BASE });
apiAdmin.interceptors.request.use((config) => {
  const t = getAdminAuth();
  if (t) config.headers['Authorization'] = `Basic ${t}`;
  return config;
});
